import { env } from 'utils/helpers';

export const BACKGROUND_PATH = env('REACT_APP_BACKGROUND_PATH') || 'data/white-label';
